import(/* webpackMode: "eager" */ "/codebuild/output/src2507380620/src/Land-Based-CasinoStars-Admin/src/app/page.jsx");
